import { useEffect } from "react";

// Re-runs fetcher when the tab regains focus/visibility and on an interval, so admin edits show up live.
export default function useLiveRefresh(fetcher, intervalMs = 30000) {
  useEffect(() => {
    fetcher();
    const onVisible = () => { if (document.visibilityState === "visible") fetcher(); };
    const id = setInterval(onVisible, intervalMs);
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", fetcher);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", fetcher);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
